/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Aggregations } from './Aggregations';
import {
    AggregationsFromJSON,
    AggregationsFromJSONTyped,
    AggregationsToJSON,
    AggregationsToJSONTyped,
} from './Aggregations';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
    SortOrderToJSONTyped,
} from './SortOrder';
import type { QueryExpression } from './QueryExpression';
import {
    QueryExpressionFromJSON,
    QueryExpressionFromJSONTyped,
    QueryExpressionToJSON,
    QueryExpressionToJSONTyped,
} from './QueryExpression';

/**
 * Search request for MaterialMean logistics objects.
 * @export
 * @interface SearchMaterialMeansRequest
 */
export interface SearchMaterialMeansRequest {
    /**
     * 
     * @type {QueryExpression}
     * @memberof SearchMaterialMeansRequest
     */
    query?: QueryExpression;
    /**
     * Sorting specification.
     * @type {Array<{ [key: string]: SortOrder; }>}
     * @memberof SearchMaterialMeansRequest
     */
    sort?: Array<{ [key: string]: SortOrder; }>;
    /**
     * 
     * @type {Aggregations}
     * @memberof SearchMaterialMeansRequest
     */
    aggregations?: Aggregations;
}

/**
 * Check if a given object implements the SearchMaterialMeansRequest interface.
 */
export function instanceOfSearchMaterialMeansRequest(value: object): value is SearchMaterialMeansRequest {
    return true;
}

export function SearchMaterialMeansRequestFromJSON(json: any): SearchMaterialMeansRequest {
    return SearchMaterialMeansRequestFromJSONTyped(json, false);
}

export function SearchMaterialMeansRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchMaterialMeansRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'query': json['query'] == null ? undefined : QueryExpressionFromJSON(json['query']),
        'sort': json['sort'] == null ? undefined : json['sort'],
        'aggregations': json['aggregations'] == null ? undefined : AggregationsFromJSON(json['aggregations']),
    };
}

export function SearchMaterialMeansRequestToJSON(json: any): SearchMaterialMeansRequest {
    return SearchMaterialMeansRequestToJSONTyped(json, false);
}

export function SearchMaterialMeansRequestToJSONTyped(value?: SearchMaterialMeansRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'query': QueryExpressionToJSON(value['query']),
        'sort': value['sort'],
        'aggregations': AggregationsToJSON(value['aggregations']),
    };
}

